export enum PricingSchemas {
  Child = 1,
  Student = 2,
  Adult = 3,
  Senior = 4,
  ExtraBed = 5,
}

export enum PluralPricingSchemas {
  Child = 'Children',
  Student = 'Students',
  Adult = 'Adults',
  Senior = 'Seniors',
  ExtraBed = 'Extra Beds',
}

export enum PaymentSystem {
  Bank = 1,
  Stripe = 2,
  PayNet = 4,
}
